import { useTranslation } from 'react-i18next';
import { IconFilePencil } from '@tabler/icons-react';
import GateBanner from '@/components/common/GateBanner';
import { ROUTES } from '@/routes/paths';

// Ограничение раздела «Продам»: пока не подписан агентский договор — предлагаем подписать. Специфично
// разделу «Продам» (не блокирует «Купить», не висит в глобальном баннере обязательных данных). Вид —
// общий GateBanner, диплинк прямо на подписание в «Моей компании».
export default function AgencyGateBanner() {
  const { t } = useTranslation();
  return (
    <GateBanner
      icon={<IconFilePencil size={20} />}
      to={ROUTES.APP_COMPANY_AGENCY}
      title={t('app.sell.gate.title')}
      text={t('app.sell.gate.text')}
      action={t('app.sell.gate.action')}
    />
  );
}
